<script setup lang="ts">
import { ALERT_STATUS } from "~/common/interfaces/alert-status.enum";
import { useAlertStore } from "~/stores/alert";
import { useCollectionsStore } from "~/stores/collections";
import { useModalStore } from "~/stores/modal";

const { t } = useI18n();
const route = useRoute();
const alertStore = useAlertStore();
const { collectionsConfirmDelete } = useModalStore();
const collectionsStore = useCollectionsStore();

const submitCollectionDelete = async () => {
	await collectionsStore.deleteById(collectionsConfirmDelete.collection.id);

	collectionsConfirmDelete.closeModal();

	if (route.name === "products-collections-collection") {
		navigateTo("/products/collections");
	} else if (route.name === "products-collections") {
		collectionsStore.getAll({}, collectionsStore.recentGetAllQuery);
	}

	alertStore.addAlert({
		title: t("COMPONENTS.COLLECTIONS.CONFIRM_DELETE.alert.title"),
		description: t("COMPONENTS.COLLECTIONS.CONFIRM_DELETE.alert.description", { collectionName: collectionsConfirmDelete.collection.name }),
		status: ALERT_STATUS.SUCCESS
	});
};
</script>

<template>
	<AppModalConfirm
		:title="$t('COMPONENTS.COLLECTIONS.CONFIRM_DELETE.title')"
		:description="$t('COMPONENTS.COLLECTIONS.CONFIRM_DELETE.description', {collectionName: collectionsConfirmDelete.collection.name})"
		:close-button-text="$t('COMMON.noCancel')"
		:submit-button-text="$t('COMMON.yesDelete')"
		@close="collectionsConfirmDelete.closeModal"
		@submit="submitCollectionDelete"
	/>
</template>
